import { render, staticRenderFns } from "./AddSpecimenToSale.vue?vue&type=template&id=c806e432&scoped=true"
import script from "./AddSpecimenToSale.vue?vue&type=script&lang=js"
export * from "./AddSpecimenToSale.vue?vue&type=script&lang=js"
import style0 from "./AddSpecimenToSale.vue?vue&type=style&index=0&id=c806e432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c806e432",
  null
  
)

export default component.exports